import { createSelector } from "reselect";

import Dimensions from "../../constants/styles/dimensions";
import { appStateSelectors } from "../../modules/appState";
import { typeSelectors } from "../../modules/definition/types";
import { immutableRecords } from "../../types";

const getSidebarWidth = (leftPadding = 0) => Dimensions.SIDEBAR_WIDTH + leftPadding;

const mapTypeToDropdownOption = (t, disabled) =>
  immutableRecords.DropdownOptionRecord({
    label: t.label,
    value: t.id,
    color: t.color,
    icon: t.icon,
    disabled
  });

const getTypeOptions = createSelector(
  // fetch parameters for last calculate function
  typeSelectors.getOrderedTypes,
  state => appStateSelectors.getTypeIdsForView(state, appStateSelectors.getActiveViewId(state)),
  typeSelectors.getSidebarTypeIds,
  // Calculate result
  (types, viewTypeIds, sidebarIds) => {
    return types
      .map(t => {
        //#!if iOS === true
// if (!viewTypeIds.contains(t.id)) {
// return null;
// }
        //#!endif
        const disabled = !sidebarIds.contains(t.id) && !viewTypeIds.contains(t.id);
        return mapTypeToDropdownOption(t, disabled);
      })
      .filter(t => t);
  }
);

const getMobileTypeOptions = createSelector(
  typeSelectors.getOrderedTypes,
  state => typeSelectors.getMobileTypeIdsByViewType(state, appStateSelectors.getMobilePortraitViewType(state)),
  (types, viewTypeIds) => types.filter(t => viewTypeIds.contains(t.id)).map(t => mapTypeToDropdownOption(t, false))
);

const getMobileLandscapeTypeOptions = state => {
  const types = typeSelectors.getOrderedTypes(state);
  const leftPanelMode = appStateSelectors.getLeftPanelMode(state);
  const activeViewId = appStateSelectors.getActiveViewId(state);
  const visibleTypeId = appStateSelectors.getVisibleTypeListId(state);

  const viewTypeIds =
    leftPanelMode && visibleTypeId
      ? typeSelectors.getTypeIdsForEntityList(state, visibleTypeId)
      : appStateSelectors.getTypeIdsForView(state, activeViewId);

  return types.filter(t => viewTypeIds.contains(t.id)).map(t => mapTypeToDropdownOption(t, false));
};

const sidebarSelectors = {
  getTypeOptions,
  getMobileTypeOptions,
  getMobileLandscapeTypeOptions,
  getSidebarWidth
};

export default sidebarSelectors;
